<template>
  <div v-if="$companyConfiguration.evaluation.isEnabled()">
    <scales-component></scales-component>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import ScalesComponent from "@/modules/evaluation/components/scale/ScalesComponent.vue";

export default {
  name: 'eval-scales',
  components: {
    PageHeading,
    ScalesComponent,
  },
}
</script>

<style scoped lang="scss">
  @import "./src/assets/css/project-variables";
</style>